export const SERVICE_STAGES = {
  INCOMING: "incoming",
  QUEUE: "queue",
  PENDING: "pending",
  VALIDATION: "validation",
  DELIVERY: "delivery",
  DONE: "done",
};

export const SERVICE_STAGE_LABELS = {
  [SERVICE_STAGES.INCOMING]: "Incoming",
  [SERVICE_STAGES.QUEUE]: "Queue",
  [SERVICE_STAGES.PENDING]: "Pending",
  [SERVICE_STAGES.VALIDATION]: "Validation",
  [SERVICE_STAGES.DELIVERY]: "Delivery",
  [SERVICE_STAGES.DONE]: "Done",
};

export const SERVICE_CATEGORIES = {
  SOLD: "sold",
  RENTAL: "rental",
  STOCK: "stock",
};

export const SERVICE_CATEGORY_LABELS = {
  [SERVICE_CATEGORIES.SOLD]: "Sold",
  [SERVICE_CATEGORIES.RENTAL]: "Rental",
  [SERVICE_CATEGORIES.STOCK]: "Stock",
};

export const SERVICE_DVT_STATUSES = {
  DOA: "doa",
  IN_WARRANTY: "in_warranty",
  OUT_OF_WARRANTY: "out_of_warranty",
  VOID: "void",
};

export const SERVICE_DVT_STATUS_LABELS = {
  [SERVICE_DVT_STATUSES.DOA]: "DOA",
  [SERVICE_DVT_STATUSES.IN_WARRANTY]: "In Warranty",
  [SERVICE_DVT_STATUSES.OUT_OF_WARRANTY]: "Out of Warranty",
  [SERVICE_DVT_STATUSES.VOID]: "Void",
};

export const SERVICE_BRANCHES = {
  JAKARTA: "jakarta",
  SURABAYA: "surabaya",
  BALI: "bali",
};

export const SERVICE_BRANCH_LABELS = {
  [SERVICE_BRANCHES.JAKARTA]: "Jakarta",
  [SERVICE_BRANCHES.SURABAYA]: "Surabaya",
  [SERVICE_BRANCHES.BALI]: "Bali",
};

export const SERVICE_ERROR_LABELS = {
  CANNIBAL_DONOR_DUPLICATE_SERIAL: "A Cannibal donor with this Serial Number already exists.",
  CANNIBAL_DONOR_TRANSFERRED: "This Cannibal donor has already been transferred.",
  CANNIBAL_PART_ALREADY_ACTIVE: "This part is already recorded as removed from the donor.",
  CANNIBAL_STATE_CHANGED: "Cannibal donor state changed. Refresh and try again.",
  CANNIBAL_BRANCH_EDIT_BLOCKED: "Branch cannot be changed while active Cannibal Usage exists.",
  CANNIBAL_TRANSFER_ALREADY_CREATED: "A Service Stock ticket has already been created for this donor.",
  CANNIBAL_SELECTION_REQUIRED: "Select one Cannibal donor and at least one part.",
  CANNIBAL_BRANCH_MISMATCH: "The donor and recipient ticket must use the same Branch.",
  SERVICE_DATE_IN_BEFORE_PURCHASE: "Date In cannot be before the purchase date.",
  SERVICE_DELETE_BLOCKED: "Resolve linked active Holds and linked active or legacy-active Usage before deleting this ticket.",
  SERVICE_EMPTY_UPDATE: "No changes were submitted.",
  SERVICE_EXTERNAL_API_UNAVAILABLE: "The external Service lookup is currently unavailable.",
  SERVICE_FORBIDDEN: "You do not have permission to perform this Service action.",
  SERVICE_HOLD_ALREADY_LINKED: "This Hold is already linked to another Service ticket.",
  SERVICE_HOLD_NOT_ACTIVE: "This Hold is not active.",
  SERVICE_HOLD_NOT_FOUND: "Hold was not found.",
  SERVICE_INVALID_TRANSITION: "This stage transition is not allowed.",
  SERVICE_IDEMPOTENCY_CONFLICT: "This request conflicts with an earlier Service request.",
  SERVICE_REQUIRED_STAGE_FIELDS_MISSING: "Required fields are missing for the target stage.",
  SERVICE_RESTRICTED_FIELD: "This field cannot be changed here.",
  SERVICE_TECHNICIAN_INACTIVE: "The selected technician is inactive.",
  SERVICE_TECHNICIAN_NOT_FOUND: "Technician was not found.",
  SERVICE_TICKET_DELETED: "This Service ticket has been deleted.",
  SERVICE_TICKET_NUMBER_COLLISION: "A unique Service ticket number could not be generated.",
  SERVICE_TICKET_NUMBER_EXHAUSTED: "Service ticket numbering is temporarily exhausted.",
  SERVICE_TICKET_NOT_FOUND: "Service ticket was not found.",
  SERVICE_TRANSACTION_FAILED: "Service operation failed.",
  SERVICE_UNKNOWN_SN_CONFIRMATION_REQUIRED: "Unknown serial number requires confirmation.",
  SERVICE_USAGE_NUMBER_COLLISION: "A unique spare-part Usage number could not be generated.",
  SERVICE_USAGE_NOT_FOUND: "Usage was not found.",
  SERVICE_USAGE_WRONG_TICKET: "Usage does not belong to this Service ticket.",
  SERVICE_VALIDATION_ERROR: "Please review the Service form fields.",
  SERVICE_WARRANTY_VOID_INVALID: "Please review the Void Warranty change.",
};

export const SERVICE_REPAIR_ACTIONS = {
  PART_REPLACE: "part_replace",
  PART_REPAIR: "part_repair",
  SOFTWARE_REPAIR: "software_repair",
  CANCEL_SERVICE: "cancel_service",
};

export const SERVICE_REPAIR_ACTION_LABELS = {
  part_replace: "Part Replace",
  part_repair: "Part Repair",
  software_repair: "Software Repair",
  cancel_service: "Cancel Service",
};

export const SERVICE_AUDIT_ACTIONS = {
  CREATE: "service_ticket.create",
  EDIT: "service_ticket.edit",
  MOVE: "service_ticket.move",
  ADMIN_EDIT_STAGE: "service_ticket.admin_edit_stage",
  SOFT_DELETE: "service_ticket.soft_delete",
  RESTORE: "service_ticket.restore",
  HOLD_TO_USE: "service_ticket.hold_to_use",
  USED_TO_HOLD: "service_ticket.used_to_hold",
};

export const SERVICE_AUDIT_ACTION_LABELS = {
  [SERVICE_AUDIT_ACTIONS.CREATE]: "Service Ticket Created",
  [SERVICE_AUDIT_ACTIONS.EDIT]: "Service Ticket Updated",
  [SERVICE_AUDIT_ACTIONS.MOVE]: "Service Ticket Moved",
  [SERVICE_AUDIT_ACTIONS.ADMIN_EDIT_STAGE]: "Service Ticket Stage Changed by Admin",
  [SERVICE_AUDIT_ACTIONS.SOFT_DELETE]: "Service Ticket Deleted",
  [SERVICE_AUDIT_ACTIONS.RESTORE]: "Service Ticket Restored",
  [SERVICE_AUDIT_ACTIONS.HOLD_TO_USE]: "Spare Part Moved to Used",
  [SERVICE_AUDIT_ACTIONS.USED_TO_HOLD]: "Spare Part Returned to Hold",
};

export const SERVICE_AUDIT_ACTION_OPTIONS = Object.values(SERVICE_AUDIT_ACTIONS).map(
  (value) => ({ value, label: SERVICE_AUDIT_ACTION_LABELS[value] })
);

export const SERVICE_AUDIT_ENTITY_TYPES = {
  SERVICE_TICKET: "service_ticket",
  SPARE_PART_USAGE: "spare_part_usage",
};

export const SERVICE_AUDIT_ENTITY_LABELS = {
  [SERVICE_AUDIT_ENTITY_TYPES.SERVICE_TICKET]: "Service Ticket",
  [SERVICE_AUDIT_ENTITY_TYPES.SPARE_PART_USAGE]: "Spare Part Usage",
};

export const SERVICE_AUDIT_ENTITY_OPTIONS = Object.values(SERVICE_AUDIT_ENTITY_TYPES).map(
  (value) => ({ value, label: SERVICE_AUDIT_ENTITY_LABELS[value] })
);

export const SERVICE_AUDIT_BADGE_CLASSES = {
  [SERVICE_AUDIT_ACTIONS.CREATE]:
    "bg-semantic-success text-semantic-success border-success/30",
  [SERVICE_AUDIT_ACTIONS.EDIT]: "bg-semantic-info text-semantic-info border-info/30",
  [SERVICE_AUDIT_ACTIONS.MOVE]:
    "bg-semantic-movement text-semantic-movement border-semantic-movement",
  [SERVICE_AUDIT_ACTIONS.ADMIN_EDIT_STAGE]:
    "bg-semantic-warning text-semantic-warning border-warning/30",
  [SERVICE_AUDIT_ACTIONS.SOFT_DELETE]:
    "bg-semantic-danger text-semantic-danger border-semantic-danger",
  [SERVICE_AUDIT_ACTIONS.RESTORE]:
    "bg-semantic-success text-semantic-success border-success/30",
  [SERVICE_AUDIT_ACTIONS.HOLD_TO_USE]:
    "bg-semantic-success text-semantic-success border-success/30",
  [SERVICE_AUDIT_ACTIONS.USED_TO_HOLD]:
    "bg-semantic-danger text-semantic-danger border-semantic-danger",
};

export const SERVICE_AUDIT_BADGE_TONES = {
  [SERVICE_AUDIT_ACTIONS.CREATE]: "success",
  [SERVICE_AUDIT_ACTIONS.EDIT]: "info",
  [SERVICE_AUDIT_ACTIONS.MOVE]: "custom",
  [SERVICE_AUDIT_ACTIONS.ADMIN_EDIT_STAGE]: "warning",
  [SERVICE_AUDIT_ACTIONS.SOFT_DELETE]: "danger",
  [SERVICE_AUDIT_ACTIONS.RESTORE]: "success",
  [SERVICE_AUDIT_ACTIONS.HOLD_TO_USE]: "success",
  [SERVICE_AUDIT_ACTIONS.USED_TO_HOLD]: "danger",
};

export const SERVICE_AUDIT_FALLBACK_BADGE_TONE = "neutral";

export const SERVICE_AUDIT_CHANGE_LABELS = {
  stage: "Stage",
  problem: "Problem",
  root_cause: "Root Cause",
  resolution: "Resolution",
  pending_reason: "Pending Reason",
  repair_action: "Repair Action",
  technician: "Technician",
  technician_id: "Technician",
  expedition: "Expedition",
  tracking_number: "Tracking Number",
  notes: "Notes",
  category: "Category",
  branch: "Branch",
  "warranty.dvt.status": "DVT Warranty Status",
};
